import React, { useEffect, useState } from "react";
import {
  Container,
  Heading,
  SimpleGrid,
  Box,
  Image,
  Text,
  useColorModeValue,
  AspectRatio,
  Link as ChakraLink,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import materialsService from "../services/materialsService";

const imgFor = (name) =>
  `https://source.unsplash.com/collection/190727/1600x1200?${encodeURIComponent(
    name
  )}`;

const Categories = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    let active = true;
    materialsService.listMaterials({ limit: 1000 }).then((result) => {
      if (!active) return;
      const materials = Array.isArray(result) ? result : result?.items || [];
      const unique = new Map();
      materials.forEach((material) => {
        const category = material.category || {};
        const id = category._id || category.id || material.categoryId;
        if (!id || unique.has(String(id))) return;
        unique.set(String(id), {
          slug: String(id),
          title: category.name || material.categoryName || String(id),
        });
      });
      setCategories(Array.from(unique.values()));
    }).catch(() => {
      if (active) setCategories([]);
    });
    return () => { active = false; };
  }, []);
  const bg = useColorModeValue("#FAFAFA", "gray.900");
  const cardBg = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("#111", "#eee");

  return (
    <section aria-labelledby="categories-heading" style={{ background: bg }}>
      <Container
        maxW="100%"
        px={{ base: "16px", md: "20px", xl: "32px" }}
        py={{ base: "24px", md: "32px", xl: "48px" }}
      >
        <Heading
          as="h1"
          id="categories-heading"
          textTransform="uppercase"
          letterSpacing="0.02em"
          fontWeight="500"
          fontSize={{ base: "22px", md: "30px", xl: "38px" }}
          mb={{ base: 4, md: 5, xl: 6 }}
        >
          Categories
        </Heading>

        <SimpleGrid
          as="ul"
          columns={{ base: 1, sm: 2, md: 3, xl: 4 }}
          gap={{ base: 3, sm: 4, md: 6, xl: 8 }}
        >
          {categories.map((cat, idx) => (
            <Box
              as="li"
              key={cat.slug}
              listStyleType="none"
              borderRadius="16px"
              overflow="hidden"
              bg={cardBg}
              boxShadow="0 4px 16px rgba(0,0,0,0.06)"
              role="group"
              display="flex"
              flexDirection="column"
              h="100%"
            >
              <ChakraLink
                as={Link}
                to={`/categories/${cat.slug}`}
                aria-label={`Browse ${cat.title} categories`}
                display="block"
                h="100%"
                _focus={{ boxShadow: "0 0 0 3px rgba(30,144,255,0.16)" }}
              >
                <AspectRatio
                  ratio={16 / 9}
                  flex="1"
                  maxH={{
                    base: "220px",
                    sm: "260px",
                    md: "300px",
                    xl: "340px",
                  }}
                >
                  <Image
                    // src={imgFor(cat.title)}
                    src="https://m.media-amazon.com/images/I/61-O10+QdeL._SL1500_.jpg"
                    alt={`${cat.title} category hero`}
                    objectFit="cover"
                    width="100%"
                    height="100%"
                    loading={idx < 4 ? "eager" : "lazy"}
                    decoding="async"
                    fallbackSrc="https://m.media-amazon.com/images/I/61-O10+QdeL._SL1500_.jpg"
                  />
                </AspectRatio>

                <Box
                  p={{ base: 3, md: 4 }}
                  bg={cardBg}
                  display="flex"
                  alignItems="center"
                >
                  <Text
                    as="span"
                    textTransform="uppercase"
                    fontSize={{ base: "14px", md: "16px" }}
                    letterSpacing="0.04em"
                    fontWeight="600"
                    color={textColor}
                    flex="1"
                  >
                    {cat.title}
                  </Text>
                  <Text fontSize="sm" color="gray.500">
                    Browse
                  </Text>
                </Box>
              </ChakraLink>
            </Box>
          ))}
        </SimpleGrid>
      </Container>
    </section>
  );
};

export default Categories;
